import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TimeEntry, TrackResponse } from '../models/common';
import { ApiService } from './api.service';

export interface Track {
  id: number;
  userId: number;
  cpid: number;
  ticketId: string;
  taskTypeId: number;
  startTime: string;
  endTime: string;
  timeSpent: string;
  comment: string;
  isJiraTask: boolean;
  createdDateTime: string;
  modifiedDateTime: string;
  createdBy?: string;
  modifiedBy?: string;
  projectId: number;
  projectName: string;
  taskName: string;
  taskDate: string;
}
export interface TrackApprovalResponse {
  taskDate: string;
  totalTimeSpent: string;
  comments: string;
  status: string;
  approvedById: number;
  approvedByName: string;
  submittedOn: string;
  responsesUpdatedOn: string;
  timeEntryApprovalId: number;
}
export interface SearchTrackResponse {
  timeEntries?: Track[];
  totalTimeSpent?: string;
}

@Injectable({
  providedIn: 'root',
})
export class TrackerService {
  private readonly endpoint = 'time-entry';
  constructor(private apiService: ApiService) {}

  getTrack(startDate: string, endDate: string) {
    const params = new HttpParams()
      .set('StartDate', startDate)
      .set('EndDate', endDate);
    return this.apiService.get<TrackResponse>(
      this.endpoint + '/my-time-entries',
      {
        params,
      },
    );
  }

  createTrack(project: TimeEntry) {
    return this.apiService.post<TimeEntry>(this.endpoint, project);
  }

  updateTrack(id: number, project: Partial<TimeEntry>): Promise<TimeEntry> {
    return this.apiService.put<TimeEntry>(`${this.endpoint}/${id}`, project);
  }

  deleteTrack(id: any): Promise<void> {
    id = {
      ids: id,
    };
    return this.apiService.delete<void>(`${this.endpoint}`, id);
  }

  getTrackByUserId(
    userId: number,
    startDate?: string,
    endDate?: string,
    ProjectId?: number | null,
  ) {
    let params = new HttpParams()
      .set('UserId', userId)
      .set('StartDate', startDate || '')
      .set('EndDate', endDate || '');
    if (ProjectId) {
      params = params.set('ProjectId', ProjectId.toString());
    }

    return this.apiService.get<SearchTrackResponse>(`${this.endpoint}`, {
      params,
    });
  }
  createTrackMyTeam(project: TimeEntry) {
    return this.apiService.post<TimeEntry>('my-team/time-entry', project);
  }
  getApprovalTrack(startDate?: string, endDate?: string, statuses?: string[]) {
    let params = new HttpParams()
      .set('StartDate', startDate || '')
      .set('EndDate', endDate || '');
    if (statuses) {
      statuses.forEach((status) => {
        params = params.append('Statuses', status);
      });
    }
    return this.apiService.get<TrackApprovalResponse[]>(
      `time-entry-approval/my-approval-requests`,
      { params },
    );
  }
  submitForApproval(ids: { effectiveDate: string | null }[]) {
    return this.apiService.post<void>(`time-entry-approval`, ids);
  }
  reSubmitForApproval(
    ids: { effectiveDate: string | null; timeEntryApprovalId: number }[],
  ) {
    return this.apiService.put<void>(`time-entry-approval`, ids);
  }
  pullBackSubmission(ids: number[]) {
    return this.apiService.delete<void>(`time-entry-approval`, ids);
  }
}
